<template>

	<div class="Toasts">

		<div :class="toastClasses(toast)" v-for="toast in toasts" @mouseover="clearExpiry(toast)" @mouseleave="resetExpiry(toast)" >
			{{ toast.text }}
		</div>

	</div>

</template>
<script>

	export default {
		data() {
			return {
				timer : null,
				expire_after : 6, //s
				toasts : [],
			};
		},
		mounted(){
			var self = this;
			this.timer = setInterval(()=>{
				self.updateToasts();
			},500);

			Event.$on('error', (message) => {
				this.addToast({ type : 'error' , text : message });
			});

			Event.$on('success', (message) => {
				this.addToast({ type : 'success' , text : message });
			});

			Event.$on('info', (message) => {
				this.addToast({ type : 'info' , text : message });
			});

			Event.$on('toast', (data) => {
				this.addToast(data);
			});
		},
		beforeDestroy(){
			clearTimeout(this.timer);
		},
		methods : {
			updateToasts(){
				this.toasts = this.toasts.map((x)=>{
					if(x.new) x.new = moment().seconds() - x.created.seconds() < 2;
					if(!x.expiring && x.expires) x.expiring = x.expires.seconds() - moment().seconds() < 2;
					return x;
				});
				this.toasts = this.toasts.filter((x)=>!x.expires||x.expires>moment());
			},
			addToast({type,text}){
				if(text){
					this.toasts.push({
						new : true ,
						expiring : false ,
						text : text ,
						type : type || 'default',
						created : moment(),
						expires : moment().add( this.expire_after ,'seconds'),
					});
				}
			},
			toastClasses(toast){
				var classes = ['Toast',toast.type];
				if(toast.new) classes.push('new');
				if(toast.expiring) classes.push('expiring');
				return classes;
			},
			clearExpiry(toast){
				toast.expiring = false ;
				toast.expires = null;
			},
			resetExpiry(toast){
				toast.expires = moment().add( this.expire_after ,'seconds');
			},
		},
	}
</script>